// Mock data for TechFix repair shop website
export const businessInfo = {
  name: "Repairzone Π.Κ",
  tagline: "Επισκευή Κινητών • Laptop • Tablet • Υπολογιστών",
  description:
    "Επαγγελματική κατ' οίκον επισκευή ηλεκτρονικών συσκευών στη Λαμία και γύρω περιοχές (Φθιώτιδα). Γρήγορες, αξιόπιστες και οικονομικές λύσεις για όλες τις συσκευές σας.",
  phone: "6982917870",
  mobile: "6982917870",
  mobile2: "6948898658",
  email: "repairzone09@gmail.com",
  address: "Λαμία, Φθιώτιδα — Κατ' οίκον επισκευή",
  serviceArea: "Λαμία και γύρω περιοχές (Φθιώτιδα)",
  hours: [
    { day: "Δευτέρα - Κυριακή", time: "24/7 Πάντα ανοιχτά" },
  ],
  social: {
    facebook: "https://www.facebook.com/RepairzonePK",
    instagram: "https://www.instagram.com/repair_z0ne?igsh=ZmNoMTV4N3VuYnY=",
    tiktok: "#",
  },
};

export const stats = [
  { value: "10+", label: "Χρόνια Εμπειρίας" },
  { value: "15K+", label: "Επισκευές" },
  { value: "98%", label: "Ικανοποίηση" },
  { value: "24h", label: "Χρόνος Παράδοσης" },
];

export const services = [
  {
    id: 1,
    icon: "Smartphone",
    title: "Επισκευή Κινητών",
    desc: "Αλλαγή οθόνης, μπαταρίας, αναβάθμιση software, αντιμετώπιση βρεγμένων συσκευών.",
    items: ["Αλλαγή οθόνης", "Αντικατάσταση μπαταρίας", "Επισκευή θύρας φόρτισης", "Software & Flash"],
    price: "από 25€",
  },
  {
    id: 2,
    icon: "Laptop",
    title: "Επισκευή Laptop",
    desc: "Πλήρης διάγνωση και επισκευή. Αναβαθμίσεις SSD/RAM, αλλαγή πληκτρολογίου και οθόνης.",
    items: ["Αλλαγή οθόνης LCD/LED", "Καθαρισμός & Θερμοαγώγιμη πάστα", "Αναβάθμιση SSD / RAM", "Format & Εγκατάσταση Windows"],
    price: "από 35€",
  },
  {
    id: 3,
    icon: "Tablet",
    title: "Επισκευή Tablet",
    desc: "iPad, Samsung, Huawei και όλα τα μοντέλα tablet. Οθόνες, μπαταρίες, κουμπιά.",
    items: ["Αλλαγή Touch & LCD", "Αντικατάσταση μπαταρίας", "Επισκευή κουμπιών", "Software issues"],
    price: "από 30€",
  },
  {
    id: 4,
    icon: "Monitor",
    title: "Επισκευή Υπολογιστών",
    desc: "Desktop υπολογιστές, gaming PC, builds. Αντιμετώπιση hardware και software προβλημάτων.",
    items: ["Διάγνωση Hardware", "Αντικατάσταση εξαρτημάτων", "Custom Gaming Builds", "Αναβαθμίσεις"],
    price: "από 40€",
  },
  {
    id: 5,
    icon: "HardDrive",
    title: "Ανάκτηση Δεδομένων",
    desc: "Ανάκτηση φωτογραφιών, εγγράφων και αρχείων από κατεστραμμένους δίσκους και κάρτες SD.",
    items: ["Σκληροί δίσκοι HDD/SSD", "USB & Κάρτες SD", "Backup δεδομένων", "Διαγνωστικός έλεγχος"],
    price: "από 50€",
  },
  {
    id: 6,
    icon: "ShieldCheck",
    title: "Αντιμετώπιση Ιών",
    desc: "Καθαρισμός από malware, ransomware, ιούς. Ενίσχυση ασφαλείας και προστασία δεδομένων.",
    items: ["Αφαίρεση ιών & malware", "Ασφάλεια δικτύου", "Antivirus εγκατάσταση", "Tuning συστήματος"],
    price: "από 30€",
  },
  {
    id: 7,
    icon: "Gamepad2",
    title: "Καθαρισμός Gaming Consoles",
    desc: "Επαγγελματικός καθαρισμός & service σε PlayStation, Xbox και Nintendo. Αλλαγή θερμοαγώγιμης πάστας και επισκευή χειριστηρίων.",
    items: [
      "Καθαρισμός PS4 / PS5",
      "Service Xbox One / Series",
      "Θερμοαγώγιμη πάστα & pads",
      "Επισκευή χειριστηρίων",
    ],
    price: "από 25€",
  },
];

export const devices = [
  "iPhone",
  "Samsung",
  "Xiaomi",
  "Huawei",
  "OnePlus",
  "Apple MacBook",
  "Lenovo",
  "HP",
  "Dell",
  "ASUS",
  "Acer",
  "iPad",
];

export const gallery = [
  {
    src: "https://customer-assets.emergentagent.com/job_fb-profile-snapshot/artifacts/qe2vaf1m_20260524_151555.jpg",
    title: "Επισκευή χειριστηρίου PS4",
    desc: "Αποσυναρμολόγηση & αντικατάσταση εξαρτημάτων",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_fb-profile-snapshot/artifacts/8ev7wody_20260518_111615.jpg",
    title: "Service κάρτας γραφικών",
    desc: "Καθαρισμός & θερμοαγώγιμη πάστα GPU",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_fb-profile-snapshot/artifacts/msciom2g_20260517_142310.jpg",
    title: "Αλλαγή οθόνης Samsung",
    desc: "Αντικατάσταση σπασμένου touch screen",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_fb-profile-snapshot/artifacts/w1b1dwxt_20260517_105610.jpg",
    title: "Samsung Galaxy display",
    desc: "Δοκιμή νέας οθόνης πριν τη συναρμολόγηση",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_fb-profile-snapshot/artifacts/8s9deisl_20260430_165039.jpg",
    title: "Service Xiaomi Redmi 5G",
    desc: "Αποσυναρμολόγηση & επισκευή κάμερας",
  },
];

export const heroImage =
  "https://customer-assets.emergentagent.com/job_fb-profile-snapshot/artifacts/8s59e0uc_FB_IMG_1778524031599.jpg";

export const testimonials = [
  {
    name: "Γιώργος Π.",
    role: "Αθήνα",
    text: "Φοβερή εξυπηρέτηση! Μου έφτιαξαν την οθόνη του iPhone σε 30 λεπτά και η τιμή ήταν πολύ καλή. Συστήνω ανεπιφύλακτα!",
    rating: 5,
  },
  {
    name: "Μαρία Κ.",
    role: "Πελάτισσα",
    text: "Είχα κάψει τη μητρική του laptop μου και νόμιζα ότι ήταν τέλος. Οι παιδιά το επισκεύασαν τέλεια. Εξαιρετικοί επαγγελματίες.",
    rating: 5,
  },
  {
    name: "Δημήτρης Α.",
    role: "Επιχειρηματίας",
    text: "Επισκευάζουν όλους τους υπολογιστές του γραφείου μας. Πάντα γρήγοροι και αξιόπιστοι. Top service.",
    rating: 5,
  },
  {
    name: "Ελένη Σ.",
    role: "Φοιτήτρια",
    text: "Έκανα ανάκτηση δεδομένων από κατεστραμμένο σκληρό. Έσωσαν την πτυχιακή μου! Ευγνώμων.",
    rating: 5,
  },
];

export const processSteps = [
  { num: "01", title: "Διάγνωση", desc: "Δωρεάν διάγνωση και εκτίμηση κόστους εντός 24 ωρών." },
  { num: "02", title: "Προσφορά", desc: "Σαφής προσφορά χωρίς κρυφές χρεώσεις, με την έγκρισή σας." },
  { num: "03", title: "Επισκευή", desc: "Επαγγελματική επισκευή με γνήσια ή premium ανταλλακτικά." },
  { num: "04", title: "Παράδοση", desc: "Παράδοση και 6 μήνες εγγύηση σε όλες τις επισκευές." },
];
